<template>
    <div class="app">
        <div class="container-fluid">
            <div class="form-group row">
                <div class="col-md-4">
                    <label>Mês</label>
                    <br />
                    <Select2
                        v-model="model.mes"
                        :options="meses"
                        opt-id="id"
                        opt-text="text"
                        placeholder="selecione"
                    ></Select2>
                </div>
                <div class="col-md-4">
                    <label>Ano*</label>
                    <br />
                    <div>
                        <date-picker type="year" v-model="model.ano" valuetype="format"></date-picker>
                    </div>
                </div>

                <div class="col-md-5" style=" margin-left: 55%; margin-top: -3%;">
                    <button type="button" @click="clean()" class="btn btn-link">Limpar</button>
                    <button @click="search()" class="btn btn-primary">Gerar Gráfico</button>
                </div>
                <router-view></router-view>
            </div>
            <div class="grafico">
                <line-chart
                    :width="1000"
                    :height="422"
                    v-if="loaded"
                    :data="datasets"
                    :options="labels"
                />
            </div>
            <router-view></router-view>
        </div>

        <!-- <AppAside/> -->
    </div>
</template>

<script>
import Facade from "../facade/facade";
const facade = new Facade();
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import Select2 from "../components/Input/Select2";
import "vue2-datepicker/locale/pt-br";
import LineChart from "../components/chart/chart.vue";
import Collections from "../helpers/collections";

export default {
    components: {
        DatePicker,
        Select2,
        LineChart,
        Collections
    },
    data() {
        return {
            model: {
                mes: "",
                ano: ""
            },
            datasets: [
                {
                    label: "Cancelados",
                    backgroundColor: "#f87979",
                    data: [],
                    barPercentage: 0.3,
                    barThickness: 6,
                    maxBarThickness: 8,
                    minBarLength: 2,
                    category: 1.0
                },
                {
                    label: "Contratados",
                    backgroundColor: "#336899",
                    data: [],
                    barPercentage: 0.3,
                    barThickness: 6,
                    maxBarThickness: 8,
                    minBarLength: 2,
                    category: 1.0
                }
            ],
            labels: [],

            meses: Collections.meses,

            loaded: false
        };
    },
    computed: {
        name() {
            return this.$route.name;
        },

        list() {
            return this.$route.matched;
        }
    },
    methods: {
        async clean() {
            this.model = {
                ano: "",
                mes: ""
            };
        },

        async search() {
            this.loaded = false;
            try {
                let vm = this;

                let params = {};
                params.mes = vm.model.mes;
                params.ano = vm.model.ano;

                let res = await facade.searchData(params);
                let entries = Array.from(Object.keys(res.data.data));
                let labelsM = [];
                let cancelados = [];
                let contratados = [];
                for (let dia of entries) {
                    if (res.data.data[dia].cancelados != undefined) {
                        console.log(res.data.data[dia].cancelados);
                        this.cancelados = cancelados.push(
                            res.data.data[dia].cancelados
                        );
                    } else {
                        this.cancelados = cancelados.push(0);
                    }
                    if (res.data.data[dia].contratados != undefined) {
                        this.contratados = contratados.push(
                            res.data.data[dia].contratados
                        );
                    } else {
                        this.contratados = contratados.push(0);
                    }
                    if (vm.model.mes == "T") {
                        moment.locale("pt-BR");
                        dia = moment(dia).format("MMM");
                    } else {
                        dia = moment(dia).format("DD/MM");
                    }
                    this.labelsM = labelsM.push(dia);
                }

                this.datasets[0].data = cancelados;
                this.datasets[1].data = contratados;

                this.labels = labelsM;

                this.loaded = entries.length == 0 ? false : true;
                if (!this.loaded) {
                    this.$notify.warning(
                        "Não é possível gerar gráfico desta data"
                    );
                }
            } catch (e) {
                e.forEach(item => {
                    this.$notify.error(item.field, item.message);
                });
            }
        }
    }
};
</script>


<style lang="scss">
.grafico {
    display: flex;
    justify-content: center;
    margin-top: 30px;
}

.mx-input-wrapper {
    .mx-input {
        height: 36px !important;
        border-radius: 0px !important;
    }
}
</style>


// WEBPACK FOOTER //
// graphic.vue?3c3381a2